module.exports = __webpack_public_path__ + "img/bj30.53f1f234.png";